import { useContext } from "react";
import useEvent from "react-use-event-hook";

import {
  SessionStoreContext,
  type ISessionStoreContext,
} from "./session-store.context";

export const useSessionStore = (): ISessionStoreContext => {
  const ctx = useContext(SessionStoreContext);
  const reloadFallback = useEvent((): void => {
    window.location.reload();
  });

  if (ctx) {
    return ctx;
  }

  return { rebootSession: reloadFallback };
};
